import {
    putRouteStatusStartLoading,
    putRouteStatusStartRequest,
    putRouteStatusStartSuccess,
    putRouteStatusStartReject,
    putRouteStatusStartReset
} from "../../actions/route/putStatusStartRoute";

export const putRouteStatusStart = (formData) => async (dispatch, getState) => {
    dispatch(putRouteStatusStartLoading());
    try {
        const { data } = await putRouteStatusStartRequest(formData, getState);
        dispatch(putRouteStatusStartSuccess(data))
    } catch (error) {
        dispatch(putRouteStatusStartReject(error))
    } finally {
        setTimeout(() => { dispatch(putRouteStatusStartReset()) }, 3000);
    }
    return Promise.resolve();
};
